import { string, object } from '@gogame/schemas';

export const authValidationSchema = object({
  login: string().required('Login is required'),
  password: string().required('Password is required'),
});
